import React, { useEffect, useState } from "react";
import "./FroalaEditorStyles.scss";
import Froalaeditor from "froala-editor";
import FroalaEditor from "react-froala-wysiwyg";
import "froala-editor/css/froala_editor.pkgd.min.css";
import "froala-editor/js/plugins/code_view.min.js";
import "froala-editor/css/plugins/code_view.min.css";
import BulbIcon from "../../../assets/images/bulbIcon.png";

const FroalaWithoutDropdown = (props) => {
  const {
    showAIModal,
    setShowAIModal,
    showAI,
    editor,
    id,
    onChange,
    editorData,
    copy,
    froalaConfig,
  } = props;
  const [state, setState] = useState({
    open: false,
    newOption: "",
    openHelp: false,
    dropdownList: [],
    textfield: false,
    hoverOption: null,
    editedOption: null,
    dialogOptionList: [],
    selectedDropdown: null,
  });
  const { openHelp } = state;

  useEffect(() => {
    const editorInstance = editor?.current?.editor;
    let editorContent = editorInstance?.html?.get();
    if (editorContent !== editorData?.innerHTML) {
      setTimeout(() => {
        if ((!editorContent || editorContent === undefined || copy) && editorInstance && editorData?.innerHTML) {
          editorInstance?.html?.set(editorData?.innerHTML);
        }
      }, 100);
    }
  }, [editorData]);

  const handleModelChange = (model) => {
    onChange(id, model);
  };

  const openHelpDialog = () => {
    setState((prevState) => ({ ...prevState, openHelp: !openHelp }));
    setShowAIModal(!showAIModal);
  };

  Froalaeditor.DefineIcon("aiHelper", { SRC: BulbIcon, ALT: "Image button", height: 50, width: "50px", template: "image" });
  Froalaeditor.RegisterCommand("aiHelper", {
    title: "AI helper",
    focus: false,
    undo: true,
    refreshAfterCallback: true,
    callback: function () {
      openHelpDialog();
    },
  });

  if (showAI) {
    froalaConfig.toolbarButtons.aiHelper = { buttons: ["aiHelper"], align: "left" };
  }

  return (
    <div id={id} className="editor-class" style={{ width: "100%", color: "#fff", isolation: "isolate" }}>
      <FroalaEditor
        id={id}
        ref={editor}
        value={editorData}
        onModelChange={handleModelChange}
        config={{
          key: "zEG4iE3C7A8A4C4A3A4aIVLEABVAYFKc2Cb1MYGH1g1NYVMiG5G4E3A2A1C8C6D4D4C4==",
          spellCheck: true,
          imagePaste: true,
          placeholderText: " ",
          charCounterCount: false,
          quickInsertEnabled: false,
          pastePlain: true,
          pasteDeniedAttrs: ['style', 'class', 'id'],
          pasteDeniedTags: ['style'],
          wordPasteModal: false,
          imageAllowedTypes: ['jpeg', 'jpg', 'png'],
          toolbarButtonsXS: id === "agreement-editor" ? [["undo", "redo"], ["bold", "italic", "underline"]] : [],
          ...froalaConfig,
        }}
      />
    </div>
  );
};

export default FroalaWithoutDropdown;